module.exports = __webpack_public_path__ + "static/media/Frame-11.64371ebe.svg";